import {
  createFileRoute,
  Outlet,
  redirect,
  useLocation,
  useNavigate,
} from '@tanstack/react-router'
import { useEffect } from 'react'

import { WorkspaceLoadingSkeleton } from '#components/layout/workspace-loading-skeleton'
import { useLogout } from '#hooks/api/use-auth-actions'
import { useBillingAccess } from '#hooks/api/use-billing-access'
import { useAuth } from '#hooks/use-auth'

import { authQueryOptions } from '../hooks/use-auth'

export const Route = createFileRoute('/_auth')({
  beforeLoad: async ({ context, location }) => {
    const authData = await context.queryClient.ensureQueryData(authQueryOptions)

    if (!authData.user) {
      throw redirect({
        to: '/login',
        search: {
          redirect: location.href,
        },
      })
    }

    const hasTenant = !!authData.tenant_id
    const isAccessingOnboarding = location.pathname.includes('/onboarding')

    if (hasTenant && isAccessingOnboarding) {
      throw redirect({
        to: '/dashboard',
      })
    }

    if (!hasTenant && !isAccessingOnboarding) {
      throw redirect({ to: '/onboarding' })
    }
  },
  pendingComponent: WorkspaceLoadingSkeleton,
  component: AuthenticatedLayout,
})

function AuthenticatedLayout() {
  const { tenantId, isActive, role } = useAuth()
  const logout = useLogout()
  const billing = useBillingAccess(tenantId)
  const location = useLocation()
  const navigate = useNavigate()
  const exception =
    location.pathname === '/dashboard' ||
    location.pathname.startsWith('/planos') ||
    location.pathname.startsWith('/historico/pedidos') ||
    location.pathname.startsWith('/onboarding')
  const mustRedirect =
    Boolean(tenantId) &&
    !billing.isLoading &&
    !billing.accessState.canOperate &&
    !exception
  useEffect(() => {
    if (mustRedirect) void navigate({ to: '/dashboard', replace: true })
  }, [mustRedirect, navigate])
  if (tenantId && billing.isLoading) return <WorkspaceLoadingSkeleton />
  if (!isActive)
    return (
      <div className="grid min-h-svh place-items-center p-6 text-center">
        <div>
          <h1 className="text-2xl font-semibold">
            Acesso temporariamente bloqueado
          </h1>
          <p className="text-muted-foreground mt-2">
            Seu usuário foi desativado. Fale com o responsável pelo
            estabelecimento.
          </p>
          <button
            className="border-input mt-5 rounded-lg border px-4 py-2 text-sm"
            onClick={() => logout.mutate()}
          >
            Sair
          </button>
        </div>
      </div>
    )
  if (role && role !== 'admin')
    return (
      <div className="grid min-h-svh place-items-center p-6 text-center">
        <div>
          <h1 className="text-2xl font-semibold">Área exclusiva do gestor</h1>
          <p className="text-muted-foreground mt-2">
            A equipe operacional deve entrar usando o código e o PIN fornecidos
            pelo estabelecimento.
          </p>
          <button
            className="border-input mt-5 rounded-lg border px-4 py-2 text-sm"
            onClick={() => logout.mutate()}
          >
            Sair
          </button>
        </div>
      </div>
    )
  if (mustRedirect)
    return (
      <div className="grid min-h-svh place-items-center">Redirecionando…</div>
    )
  return <Outlet />
}
